import { css } from "../helpers/webComponents";
import { GameEventService } from "../services/GameEventService";
import { Page } from "../enums/Page";

const styles: string = css`
    :host {
        display: flex;
        justify-content: center;
        align-items: center;
        position: fixed;
        inset: 0;
        width: 100vw;
        height: 100vh;
        z-index: 1000;
        background-color: black;
    }
    video {
        max-width: 100%;
        height: 100%;
        object-fit: contain;
    }
    .skip-button {
        position: absolute;
        bottom: 40px;
        right: 40px;
        padding: 10px 20px;
        background: #1900ff;
        color: white;
        border-radius: 8px;
        cursor: pointer;
        font-size: 1rem;
        z-index: 1001;
    }
    .skip-button:hover {
        background: #3355ff;
    }
`;

export class EndingComponent extends HTMLElement {
    private readonly _gameEventService = new GameEventService();

    public connectedCallback(): void {
        this.attachShadow({ mode: "open" });
        this.render();
    }

    private render(): void {
        if (!this.shadowRoot) {
            return;
        }

        this.shadowRoot.innerHTML = `
            <style>${styles}</style>
            <video id="endingVideo" autoplay muted>
                <source src="./assets/video/ending-video.mp4" type="video/mp4" />
            </video>
            <div class="skip-button" id="skipBtn">Skip</div>
        `;

        const video: HTMLVideoElement | null = this.shadowRoot.querySelector<HTMLVideoElement>("#endingVideo");
        const skipBtn: HTMLDivElement | null = this.shadowRoot.querySelector<HTMLDivElement>("#skipBtn");

        if (!video) {
            return;
        }

        // After video ends → level selector
        video.addEventListener("ended", () => {
            this._gameEventService.switchPage(Page.LevelSelector);
        });

        // Skip button → level selector
        skipBtn?.addEventListener("click", () => {
            this._gameEventService.switchPage(Page.LevelSelector);
        });
    }
}

window.customElements.define("ending-component", EndingComponent);
